/* unplugin-vue-components disabled */import script from "./ImgUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImgUpload.vue?vue&type=script&setup=true&lang=ts"

import "./ImgUpload.vue?vue&type=style&index=0&id=61076160&scoped=true&lang=less"

import exportComponent from "D:\\workspace\\home-power-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61076160"]])

export default __exports__